import type { Technique } from '../types';
import { RECT_PACKING_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type RectPackingState } from './render';

export const rectPacking: Technique<RectPackingState> = {
  id: 'rect-packing',
  name: 'Rechteckpackung',
  category: 'packing',
  description: 'Rekursive Unterteilung des Negativraums, feiner nahe der Textkontur.',
  params: RECT_PACKING_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
